import Svg, { Defs, G, Path } from 'react-native-svg'

const Link = (props: any) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}>
      <Defs>
        <clipPath id="prefix__a">
          <Path transform="translate(655 136)" fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </Defs>
      <G clipPath="url(#prefix__a)" transform="translate(-655 -136)">
        <Path d="M647.629 148l19.375-19.375L686.378 148l-19.374 19.375z" fill="none" />
        <Path
          d="M667 139.928l-3.228 3.229 1.614 1.614 3.229-3.228a3.425 3.425 0 014.842 4.843l-3.228 3.228 1.614 1.615 3.229-3.229a5.707 5.707 0 00-8.072-8.072zm1.615 11.3l-3.23 3.23a3.425 3.425 0 11-4.842-4.844l3.229-3.228-1.615-1.615L658.93 148a5.707 5.707 0 108.071 8.072l3.229-3.229zm-5.65-.807l6.457-6.457 1.614 1.614-6.457 6.457z"
          fill="#0070b6"
        />
      </G>
    </Svg>
  )
}

export { Link }
